import React from 'react'

type Props = {
	children: any
	className?: string
}

const TabContent = (props: Props) => {
	const { children } = props
	return <div {...props}>{children}</div>
}

export default TabContent
